module.exports = __webpack_public_path__ + "assets/logo-white.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-white.png
// module id = 374
// module chunks = 0